import { AIIllustrationItemStatus, AIIllustrationStatusCellParams } from 'types/aiIllustration';

export function aiIllustrationItemStatusRenderer(params: AIIllustrationStatusCellParams): string {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = typeof params.value === 'string' ? parseInt(params.value, 10) : params.value;

  switch (status) {
    case AIIllustrationItemStatus.PENDING:
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';
    case AIIllustrationItemStatus.PROCESSING:
      return '<span class="fa fa-spinner fa-spin" style="color: #2196f3;" title="Processing"></span>';
    case AIIllustrationItemStatus.DONE:
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';
    case AIIllustrationItemStatus.ERROR:
      return '<span class="fa fa-bug" style="color: #f44336;" title="Error"></span>';
    case AIIllustrationItemStatus.NEEDS_REVIEW:
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';
    default:
      return '';
  }
}
